module.exports = __webpack_public_path__ + "img/Toughness.b4c9a1e8.png";